export const defaultConfig: Window['envs'] = {
  host: 'https://pan.sjtu.edu.cn',
  onlyPasswordLogin: false,
  selectOrgBeforeLogin: false,
  toolBox: ['fileCollect'],
  copyRight: '联系方式：闵行-图书信息楼(新图书馆西侧) 34206060 徐汇-教三楼一楼 62932901<br />©2023 上海交通大学网络信息中心 service@sjtu.edu.cn',
  showDownloadAppBtnInPc: true,
  loginTitleTextColor: '#FFFFFFFF',
  loginSloganTextColor: '#FFFFFFFF',
  loginMainEntrance: ['loginWithJAccount'],
  loginMoreEntrance: [],
  allowEmptyWatermarkText: true,
  showAnnouncements: true,
  logoutSSOConfig: {
urlFrom: 'server',
logoutSSOUrl: '',
target: '_self',
},
};
